export default __webpack_public_path__ + "static/media/cargo_flight.70213d72.svg";